import React from "react";

const NotFound = () => {
  return (
    <div className="">
      <div className="flex-wrap text-white min-h-screen flex items-center justify-center">
        <div className="text-2xl border-r-2 p-2">404</div>
        <span className="p-2"> This Page Not Found</span>
      </div>
    </div>
  );
};

export default NotFound;
